import React from "react";
import PatientContainer from "../containers/PatientContainer";

const Patient = () => {
    return (
        <div>
            <PatientContainer/>
        </div>
    );
}
export default Patient;